<template>
    <div class="accountData">
        <Page :renderSearchList="renderList" :searchData="searchData" :tableData="tableData" :total="total" :current="current" :pageSize="pageSize" @changeCurrrent="handleChangeCurrrent" @changePageSize="handleChangePageSize" @changeSearchDat="handleChangeSearchData" @search="handleSearch" :showDownload="false" downloadText="导出" @download="handleDownload">
            <div class="table-content" ref="tableContent" :style="`height: ${tableHeight}px`">
                <Table :data="tableData" show-summary :summary-method="getSummaries" size="medium" stripe v-if="tableData.length && !isLoading" :default-sort="defaultSort" :height="tableHeight" @sort-change="handleSortChange">
                    <el-table-column prop="createDate" label="日期" min-width="80"></el-table-column>
                    <el-table-column prop="appName" label="应用名称" min-width="100"></el-table-column>
                    <el-table-column prop="adPosName" label="广告位名称" min-width="100"></el-table-column>
                    <el-table-column prop="show" label="曝光数" min-width="70"></el-table-column>
                    <el-table-column prop="click" label="点击数" min-width="70"></el-table-column>
                    <el-table-column prop="ctr" label="点击率" min-width="80">
                        <template slot-scope="scope">
                            <span style="font-size: 12px;">{{scope.row.ctr * 100 | filtersDecimal}}%</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="activeNum" label="唤起数" min-width="70"></el-table-column>
                    <el-table-column prop="ecpm" label="ECPM" min-width="70"></el-table-column>
                    <el-table-column prop="cost" label="消耗" min-width="60"></el-table-column>
                    <el-table-column prop="predictIncome" label="ROI" min-width="60"></el-table-column>
                    <el-table-column prop="roiPrice" label="ROI结算金额" min-width="100"></el-table-column>
                    <el-table-column prop="settlePrice" label="总结算金额" min-width="100"></el-table-column>
                </Table>

                <div class="table-normal" v-if="!tableData.length && !isLoading">
                    <img src="@/assets/home/dataEffect/accountData/default_img_no_data.png" alt="">
                    <span>目前暂无数据</span>
                </div>

                <div v-if="isLoading">
                    <WfLoading></WfLoading>
                </div>
            </div>
        </Page>

        <div :class="`accountData-mobile`">
            <PageMobile title="数据报表" :renderSearchList="renderMobileList" :searchData="searchMobileData" :total="total" :current="current" :pageSize="pageSize" @changeCurrrent="handleChangeCurrrent" @search="handleSearch" @change="handleChangeSearchMobileData" :showDownload="false" @download="handleDownload">
                <div class="table-content" ref="tableContentMobile" :style="`height: ${tableHeight}px`">
                    <Table :data="tableData" show-summary :summary-method="getSummaries" size="small" :height="tableHeight" stripe v-if="tableData.length && !isLoading" :default-sort="defaultSort" @sort-change="handleSortChange">
                        <el-table-column prop="createDate" label="日期" min-width="80"></el-table-column>
                        <el-table-column prop="appName" label="应用名称" min-width="100"></el-table-column>
                        <el-table-column prop="adPosName" label="广告位名称" min-width="100"></el-table-column>
                        <el-table-column prop="show" label="曝光数" min-width="70"></el-table-column>
                        <el-table-column prop="click" label="点击数" min-width="70"></el-table-column>
                        <el-table-column prop="ctr" label="点击率" min-width="70">
                            <template slot-scope="scope">
                                <span style="font-size: 12px;">{{scope.row.ctr * 100 | filtersDecimal}}%</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="activeNum" label="唤起数" min-width="70"></el-table-column>
                        <el-table-column prop="ecpm" label="ECPM" min-width="70"></el-table-column>
                        <el-table-column prop="cost" label="消耗" min-width="60"></el-table-column>
                        <el-table-column prop="predictIncome" label="ROI" min-width="80"></el-table-column>
                        <el-table-column prop="roiPrice" label="ROI结算金额" min-width="100"></el-table-column>
                        <el-table-column prop="settlePrice" label="总结算金额" min-width="100"></el-table-column>
                    </Table>

                    <div class="table-normal" v-if="!tableData.length && !isLoading">
                        <img src="@/assets/home/dataEffect/accountData/default_img_no_data.png" alt="">
                        <span>目前暂无数据</span>
                    </div>

                    <div v-if="isLoading">
                        <WfLoading></WfLoading>
                    </div>
                </div>
            </PageMobile>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Page from '@/components/page/page.vue'
import PageMobile from '@/components/pageMobile/pageMobile.vue'
import Icon from 'iview/src/components/icon';
import WfLoading from '@/components/loading/loading.vue'
import { Table, TableColumn, Loading } from 'element-ui';
Vue.use(Table)
Vue.use(TableColumn)
import { dateFormat, isEmpty, deepClone, keepDecimalRound } from '@/utils/common.js'
import { renderList, renderMobileList } from './config'
import moment from 'moment'
import { sortDict, totalToColMap } from '@/pages/home/config.js'
import { getHideCustomerIdSearch } from './config'
import fileDownload from 'js-file-download'


export default {
    components: {
        Page,
        Icon,
        Table,
        WfLoading,
        PageMobile
    },
    data() {
        return {
            renderList: deepClone(renderList),
            renderMobileList: deepClone(renderMobileList),
            tableData: [],
            searchData: {
                startCreateDate: dateFormat(new Date(), 'YYYY-MM-DD'),
                endCreateDate: dateFormat(new Date(), 'YYYY-MM-DD'),
            },
            searchMobileData: {
                dates: [dateFormat(new Date(), 'YYYY-MM-DD'), dateFormat(new Date(), 'YYYY-MM-DD')]
            },
            isLoading: true,
            tableTotalData: {},
            total: 0,
            pageSize: 15,
            current: 1,
            tableHeight: "",
            sortFieldName: '',
            sortDirection: ''
        }
    },
    filters: {
        filtersCell(value) {
            if (value) {
                return value
            } else {
                return '--'
            }
        },
        filtersDate(value) {
            if (value) {
                return moment(value).format('YYYY-MM-DD HH:mm:ss')
            } else {
                return '--'
            }
        },
        filtersDecimal(value) {
            return keepDecimalRound(value, 2)
        }
    },
    computed: {
        defaultSort() {
            return {
                prop: this.sortFieldName,
                order: sortDict[this.sortDirection]
            }
        }
    },
    mounted() {
        if (window.innerWidth > 768) {
            this.tableHeight = this.$refs.tableContent ? this.$refs.tableContent.offsetHeight : ""
        } else {
            this.tableHeight = this.$refs.tableContentMobile ? this.$refs.tableContentMobile.offsetHeight : ""
        }

        this.initData()
        // if (!getHideCustomerIdSearch()) {
        //     this.$set(this.renderList[3], 'isHide', false)
        //     this.$set(this.renderMobileList[2], 'isHide', false)
        //     this.initPage()
        // }
    },
    methods: {
        // 初始化数据
        initData() {
            this.isLoading = true
            Promise.all([this.getTableData(), this.getTableTotalData()]).then((result) => {
                if (!isEmpty(result[1].data)) {
                    const totalData = result[1].data
                    if (!isEmpty(totalData.click) && totalData.show != 0) {
                        totalData.ctr = `${keepDecimalRound(totalData.click / totalData.show * 100, 2)}%`
                    }
                    if (!isEmpty(totalData.cost) && totalData.show != 0) {
                        totalData.ecpm = keepDecimalRound(totalData.cost / totalData.show * 1000, 2)
                    }

                    this.tableTotalData = totalData
                }
                this.tableTotalData = result[1].data || {}
                this.tableData = result[0].data.data || []
                this.total = result[0].data.total
                this.$nextTick(() => {
                    this.isLoading = false
                })
            }).catch(() => {
                this.isLoading = false
            })
        },

        // 初始化页面
        initPage() {
            Promise.all([this.getAllCustomer()]).then((result) => {
                const customerOptions = result[0].map((item) => {
                    return {
                        label: item.name,
                        value: item.customerId
                    }
                })
                this.$set(this.renderList[3], 'options', customerOptions)
                this.$set(renderMobileList[2], 'options', customerOptions)
            })
        },

        // 获取所有客户
        getAllCustomer() {
            return new Promise((resolve, reject) => {
                this.$axios({
                    url: '/api/syn/rebateDataPlat/customer/all',
                    data: {
                    },
                    method: 'GET'
                }).then((res) => {
                    resolve(res.Data)
                })
            })
        },

        // 获取账户级数据
        getTableData() {
            return new Promise((resolve, reject) => {
                this.$axios({
                    url: '/api/syn/rebateDspPlat/dspData/list',
                    data: {
                        ...this.searchData,
                        current: this.current,
                        pageSize: this.pageSize,
                        // sortFieldName: this.sortFieldName,
                        // sortDirection: this.sortDirection
                    },
                    method: 'GET'
                }).then((res) => {
                    // if (Array.isArray(res.Data.data) && res.Data.data.length) {
                    //     res.Data.data.map((item) => {
                    //         item.roi = item.cost ? (item.customerOrderValidEstimateCosPrice / item.cost).toFixed(2) : 0
                    //     })
                    // }
                    resolve(res)
                })
            })
        },

        // 处理点击下载事件
        handleDownload() {
            let loadingInstance = Loading.service({
                fullscreen: true,
                lock: true,
                text: '正在导出...',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            this.$axios({
                url: '/api/syn/rebateDataPlat/advertise/listExport',
                data: {
                    ...this.searchData,
                    current: this.current,
                    pageSize: this.pageSize
                },
                method: 'GET',
                responseType: 'blob'
            }).then((res) => {
                loadingInstance.close()
                const { data } = res, fileName = decodeURI((res).headers['content-disposition']).substring(20)
                fileDownload(data, fileName)
            }).catch(() => {
                loadingInstance.close()
            })
        },

        // 获取账户级数据汇总数据
        getTableTotalData() {
            return new Promise((resove, reject) => {
                this.$axios({
                    url: '/api/syn/rebateDspPlat/statistic/total',
                    data: {
                        ...this.searchData,
                        current: this.current,
                        pageSize: this.pageSize
                    },
                    method: 'GET'
                }).then((res) => {
                    resove(res)
                })
            })
        },

        // 处理排序改变时触发
        handleSortChange(event) {
            const { column, prop, order } = event
            this.sortDirection = sortDict[order]
            this.sortFieldName = prop
            this.getTableData().then((res) => {
                this.tableData = res.Data.data || []
                this.total = res.Data.total
            })
        },

        // 处理合计逻辑
        getSummaries(param) {
            const { columns, data } = param, sums = [], tableTotalData = { ...this.tableTotalData }
            for (let i = 0; i < columns.length; i++) {
                const columnItem = columns[i]
                if (i === 0) {
                    sums.push('合计')
                } else {
                    if (isEmpty(tableTotalData[columnItem.property])) {

                        sums.push('--')
                    } else {
                        sums.push(tableTotalData[columnItem.property])
                    }
                }
            }
            return sums;
        },

        // 处理搜索事件
        handleSearch() {
            this.current = 1
            this.initData()
        },


        // 处理移动端搜索改变事件
        handleChangeSearchMobileData(data) {
            const currData = { ...data }
            const dates = currData.dates
            delete currData.dates
            this.searchData = {
                startCreateDate: dates[0],
                endCreateDate: dates[1],
                ...currData
            }
        },

        // 点击关联计划数据时触发
        handlePlanData(column) {
            this.$router.push({
                name: 'planData',
                params: {
                    advertiseId: column.advertiseId
                }
            })
        },

        // 当前页改变时触发
        handleChangeCurrrent(current) {
            this.current = current
            this.initData()
        },

        // pageSize改变时触发
        handleChangePageSize(pageSize) {
            this.current = 1
            this.pageSize = pageSize
            this.initData()
        },

        // 处理搜索框改变时触发
        handleChangeSearchData(eventData) {
            const { data, item } = eventData, key = item.key
            if (key === "startCreateDate") {
                const renderItem = { ...this.renderList[1] }
                if (data[key]) {
                    renderItem.minDate = moment(data[key]).format('YYYY-MM-DD')
                    renderItem.maxDate = moment(data[key]).add(31, 'd').format('YYYY-MM-DD')
                    if (data.endCreateDate) {
                        const dateTime = new Date(data[key]).getTime(), endTime = new Date(data.endCreateDate).getTime()
                        if (dateTime > endTime || dateTime < endTime - 86400000 * 31) {
                            data.endCreateDate = null
                        }
                    }
                } else {
                    renderItem.minDate = ""
                    renderItem.maxDate = ""
                }
                this.$set(this.renderList, 1, renderItem)
            }
            if (key === "endCreateDate") {
                const renderItem = { ...this.renderList[0] }
                if (data[key]) {
                    renderItem.minDate = moment(data[key]).subtract(31, 'd').format('YYYY-MM-DD')
                    renderItem.maxDate = moment(data[key]).format('YYYY-MM-DD')
                    if (data.startCreateDate) {
                        const dateTime = new Date(data[key]).getTime(), startTime = new Date(data.startCreateDate).getTime()
                        if (dateTime < startTime || dateTime > startTime + 86400000 * 31) {
                            data.startCreateDate = null
                        }
                    }
                } else {
                    renderItem.minDate = ""
                    renderItem.maxDate = ""
                }
                this.$set(this.renderList, 0, renderItem)
            }
            this.searchData = data
        }
    }
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 768px) {
    .accountData {
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        padding: 20px;
        background-color: #fff;
        .accountData-mobile {
            display: none;
        }
        .accountData-content {
            flex: 1;
        }
        .accountData-bottom {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
        }
    }
}

@media screen and (max-width: 768px) {
    .accountData {
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 1.1rem 0 0;
        background-color: #f7f7f7;
        .wf-page {
            display: none;
        }
        .accountData-content {
            flex: 1;
        }
        .accountData-mobile {
            min-height: 100%;
            display: block;
            display: flex;
            flex-direction: column;
            padding: 0 0.3rem 0.3rem;
            .table-content {
                flex: 1;
                overflow-x: auto;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/dataEffect/dataReport/index.vue